var stopwatchDocumentClick = function (event) {
	// console.log("click", event);
	let stopwatch = $(event.target).closest("#stopwatch");
	if (stopwatch.length > 0) return;
	let scope = $("#stopwatch > div").scope();
	scope.$ctrl.popupToggle();
};

class StopwatchIconCtrl {
	constructor(scope, element, http, $document) {
		this.scope = scope;
		this.element = element;
		this.http = http;
		this.document = $document;
		Object.defineProperty(this, 'tasks', {
			get() {
				return scope.tasks;
			}, set(tasks) {
				if (tasks.length === undefined) return;
				scope.tasks = tasks;
				scope.tasks.forEach(task => {
					Object.defineProperty(task, "elapsedTime", {
						get() {
                            let elapsedTimeInSeconds = 0;
                            // Return pre-calculated time if paused
							if (this.paused_at) {
                                elapsedTimeInSeconds = this.elapsed_minutes * 60;
                            } else {
                                // elapsed time in minutes = elapsed_minutes (from previous pause) + (current time - started_at)
                                elapsedTimeInSeconds = this.elapsed_minutes * 60 + Math.floor((moment().valueOf() - moment(this.started_at).valueOf()) / 1000);
                            }
                            // calculate hrs, mins, secs
                            let hours = Math.floor(elapsedTimeInSeconds / 3600);
                            let minutes = Math.floor((elapsedTimeInSeconds % 3600) / 60);
                            let seconds = elapsedTimeInSeconds % 60;
                            if (hours === 0 && minutes === 0) {
                                return seconds.toString() + 's ';
                            }
                            if (hours === 0 ) {
                                return minutes.toString() + 'm ';
                            }
                            return hours.toString() + 'h ' + minutes.toString() + 'm ';
						}
					});
                    Object.defineProperty(task, "elapsedTimeInMinutes", {
                        get() {
                            let elapsedTimeInMinutes = 0;
                            // Return pre-calculated time if paused
                            if (this.paused_at) {
                                elapsedTimeInMinutes = this.elapsed_minutes;
                            } else {
                                // elapsed time in minutes = elapsed_minutes (from previous pause) + (current time - started_at)
                                elapsedTimeInMinutes = this.elapsed_minutes + Math.floor((moment().valueOf() - moment(this.started_at).valueOf()) / 1000 / 60);
                            }

                            return elapsedTimeInMinutes;
                        }
                    });
				});
			}
		});
		let ctrl = this;

        http.get('/stopwatch/list').then(response => {
            ctrl.tasks = response.status === 200 && response.data ? response.data : [];
            // console.log("Stopwatch tasks loaded", ctrl.tasks);
        });
	}

	popupToggle() {
		let element = angular.element(this.element).find("#stopwatch-dropdown");
		let visible = element.css("display") !== "none";
		element.toggle();
		if (!visible) document.body.addEventListener("click", stopwatchDocumentClick);
		else document.body.removeEventListener("click", stopwatchDocumentClick);
	}
}

var module = angular.module('kv');
module.component('stopwatchIcon',
	{
		templateUrl: '/assets/custom/js/directives/stopwatch/stopwatch-icon.html',
		controller: StopwatchIconCtrl
	});

StopwatchIconCtrl.$inject = ["$scope", "$element", "$http", "$document"];
